/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Status_UpdatedInputs */

const en_admin_tickets_status_updated = /** @type {(inputs: Admin_Tickets_Status_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status updated`)
};

const zh_admin_tickets_status_updated = /** @type {(inputs: Admin_Tickets_Status_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状态已更新`)
};

/**
* | output |
* | --- |
* | "Status updated" |
*
* @param {Admin_Tickets_Status_UpdatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_status_updated = /** @type {((inputs?: Admin_Tickets_Status_UpdatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Status_UpdatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_status_updated(inputs)
	return zh_admin_tickets_status_updated(inputs)
});
export { admin_tickets_status_updated as "admin.tickets.status_updated" }